import React from 'react';

const ConfirmationInstructions = () => {
  return (
    <section className="instructions columns">
      <p className="instructions__heading">Using your code:</p>
      <ol className="instructions__list">
        <li>Save your press release code (you can find it above and in your confirmation email)</li>
        <li>
          Post a press release on any of our
          {' '}
          <a href="https://www.industrydive.com/post-press-release/#post-now">publication sites</a>
        </li>
        <li>Use your redemption code when checking out</li>
      </ol>
    </section>
  );
};

export default ConfirmationInstructions;
